export default __webpack_public_path__ + "static/media/pictogramThumbDown48.c631197d.svg";